//用户管理
export default  [
  {
    path: '/informationManage',
    component: () => import("../pages/operManage/informationManage/informationManage.vue"),
    name: 'informationManage',
    title: "资讯管理",
    meta: {
      title: "资讯管理"
    }
  },
  {
    path: '/bannerManage',
    component: () => import("../pages/operManage/bannerManage.vue"),
    name: 'bannerManage',
    title: "轮播图管理",
    meta: {
      title: "轮播图管理"
    }
  },
  {
    path: '/adManage',
    component: () => import("../pages/operManage/adManage.vue"),
    name: 'adManage',
    title: "营销投放",
    meta: {
      title: "营销投放"
    }
  },
  {
    path: '/firstPage',
    component: () => import("../pages/operManage/firstPage/firstPage.vue"),
    name: 'firstPage',
    title: "金刚区配置",
    meta: {
      title: "金刚区配置"
    }
  },
  {
    path: '/ticketPointManage',
    component: () => import("../pages/operManage/ticketPointManage.vue"),
    name: 'ticketPointManage',
    title: "内部领票点管理",
    meta: {
      title: "内部领票点管理"
    }
  },
  {
    path: '/systemMessage',
    component: () => import("../pages/operManage/systemMessage.vue"),
    name: 'systemMessage',
    title: "系统消息管理",
    meta: {
      title: "系统消息管理"
    }
  },
  {
    path: '/distributionQrCodeManage',
    component: () => import("../pages/operManage/distributionQrCodeManage.vue"),
    name: 'distributionQrCodeManage',
    title: "分销码管理",
    meta: {
      title: "分销码管理"
    }
  },
  {
    path: '/customTopic',
    component: () => import("../pages/operManage/customTopic.vue"),
    name: 'customTopic',
    title: "定制专题管理",
    meta: {
      title: "定制专题管理"
    }
  },
  
  {
    path: '/hotelReco',
    component: () => import("../pages/operManage/hotelReco/hotelReco.vue"),
    name: 'hotelReco',
    title: " 酒店首页推荐管理",
    meta: {
      title: "酒店首页推荐管理"
    }
  },
  {
    path: '/firstReco',
    component: () => import("../pages/operManage/firstReco/firstReco.vue"),
    name: 'firstReco',
    title: "首页推荐",
    meta: {
      title: "首页推荐"
    }
  },
  {
    path: '/choiceManage',
    component: () => import("../pages/operManage/choiceManage/choiceManage.vue"),
    name: 'choiceManage',
    title: "好物推荐",
    meta: {
      title: "好物推荐"
    }
  },
  {
    path: '/homeMould',
    component: () => import("../pages/operManage/homeMould.vue"),
    name: 'homeMould',
    title: "首页版块配置",
    meta: {
      title: "首页版块配置"
    }
  },
  {
    path: '/hotCouponManage',
    component: () => import("../pages/operManage/hotCouponManage.vue"),
    name: 'hotCouponManage',
    title: "热销卡券",
    meta: {
      title: "热销卡券"
    }
  },
  {
    path: '/presentBooksManage',
    component: () => import("../pages/operManage/presentBook.vue"),
    name: 'presentBooksManage',
    title: "公益图书",
    meta: {
      title: "公益图书"
    }
  },
  {
    path: '/articleStatistics',
    component: () => import("../pages/operManage/articleStatistics.vue"),
    name: 'articleStatistics',
    title: "文章统计分析",
    meta: {
      title: "文章统计分析"
    }
  }
];
